import styled from "styled-components";
import { useState, useEffect } from "react";
import BranchSettingsLeftPane from "./BranchSettingsLeftPane";
import request from "../../../../api/request";
import BranchSettingsRightPane from "./BranchSettingsRightPane";
import { NotificationManager } from 'react-notifications';

const StyledBranchSettings = styled.div`
    display: flex;
`;

function BranchSettings(props) {

    const [loadedPage, setLoadedPage] = useState(false);
    const [branches, setBranches] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [selectedBranchId, setSelectedBranchId] = useState(null);
    const [regionsList, setRegionsList] = useState([]);
    const [gridColumns, setGridColumns] = useState([
        {id: 'Name', type: 'String', width: 170, textAlign: 'left'},
        {id: 'Branch', type: 'String', width: 70, textAlign: 'center'},
        {id: 'Sub', type: 'String', width: 60, textAlign: 'center'}
    ]);
    const [gridData, setGridData] = useState({groups: ['Type: Branches', 'Type: Sub-branches'], items: [[], []]});
    const [isAddMode, setIsAddMode] = useState(false);

    const onSelectGridItem = (item) => {
        props.setSmallPageTitle(item.Name);
        setSelectedBranchId(item.Id);
        setSelectedBranch(branches[item.Id]);
    }

    const fetchBranches = async (branchCommitteeCodeToSelect, branchType) => {
        try {
            let branches = [];
            let gridDataBranches = [];
            let gridDataSubBranches = [];

            let resp = (await request('database', 'fetchBranches'));
            if (resp.ok) {
                resp.data.map((branch, index) => {
                    branches.push(branch);
                    if (branch.RecordType === 1) {
                        gridDataBranches.push({Id: index, Name: branch.RecordName, Branch: branch.BranchCommitteeCode, Sub: branch.DivisionCode});
                    } else if (branch.RecordType === 2) {
                        gridDataSubBranches.push({Id: index, Name: branch.RecordName, Branch: branch.BranchCommitteeCode, Sub: branch.DivisionCode});
                    }

                    if (branchCommitteeCodeToSelect && branch.BranchCommitteeCode === branchCommitteeCodeToSelect && branch.RecordType === branchType) {
                        setSelectedBranchId(index);
                        setSelectedBranch(branch);
                    }
                });
                setBranches(branches);
                if (!branchCommitteeCodeToSelect) {
                    if (selectedBranchId)
                        setSelectedBranch(branches[selectedBranchId]);
                    else {
                        setSelectedBranch(branches[0]);
                        setSelectedBranchId(0);
                    }
                }
                setGridData({groups: ['Type: Branches', 'Type: Sub-branches'], items: [gridDataBranches, gridDataSubBranches]});
            } else {
                console.log('Failed fetchBranches');
                NotificationManager.error(resp.data);
            }
        } catch (e) {
            console.log('Failed to fetch branches: ', e);
        }
    }

    const fetchRegions = async () => {
        try {
            let regions = [];
            let resp = (await request('database', 'fetchRegions'));
            if (resp.ok) {
                resp.data.map((region) => {
                    regions.push(region);
                });
                setRegionsList(regions);
            } else {
                console.log('Failed fetchRegions');
                NotificationManager.error(resp.data);
            }
        } catch (e) {
            console.log('Failed to fetch regions: ', e);
        }
    }

    useEffect(() => {
        if (!loadedPage) {
            props.setPageTitle('Branch');
            fetchBranches();
            fetchRegions();
            setLoadedPage(true);
        }
        if (selectedBranch) {
            if (!isAddMode) {
                props.setSmallPageTitle(selectedBranch.RecordName);
            } else {
                props.setSmallPageTitle('New branch');
            }
        } else {
            props.setSmallPageTitle('');
        }
    }, [selectedBranch, isAddMode]);

    return (
        <StyledBranchSettings>
            <BranchSettingsLeftPane gridColumns={gridColumns} gridData={gridData} branchIdToSelect={selectedBranchId} onSelectGridItem={(item) => onSelectGridItem(item)} isAddMode={isAddMode} setIsAddMode={(mode) => {setIsAddMode(mode)}} gridStyle={{width:300, height:450}}></BranchSettingsLeftPane>
            {loadedPage===true && (selectedBranch || isAddMode) && <BranchSettingsRightPane branches={branches} selectedBranch={selectedBranch} regionsList={regionsList} isAddMode={isAddMode} setIsAddMode={(mode) => {setIsAddMode(mode)}} refreshBranchesCallback={fetchBranches}></BranchSettingsRightPane>}
        </StyledBranchSettings>
    )
}

export default BranchSettings;